/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	ChangeDetectionStrategy,
	Component,
	TemplateRef,
	ViewChild,
	OnInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TitlePlusService } from '@services/title-plus/title-plus.service';
import { take } from 'rxjs/operators';
import { NavigationService } from '@services/nav/nav.service';
import { TestHooks } from './title-plus-callback.hooks';

enum CallbackState {
	saving = 'saving',
	error = 'error',
	success = 'success',
}

@UntilDestroy()
@Component({
	selector: 'app-title-plus-callback',
	templateUrl: './title-plus-callback.component.html',
	styleUrls: ['./title-plus-callback.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitlePlusCallbackComponent implements OnInit {
	testHooks = TestHooks;
	public ICON = ICON;
	public states = CallbackState;
	public state: CallbackState = CallbackState.saving;

	@ViewChild('successDialogTemplate') successDialogTemplate: TemplateRef<any>;

	constructor(
		private activatedRoute: ActivatedRoute,
		private titlePlusService: TitlePlusService,
		private dialog: MatDialog,
		private navService: NavigationService,
	) {}

	ngOnInit(): void {
		this.activatedRoute.queryParams
			.pipe(untilDestroyed(this))
			.subscribe((params) => {
				const code = params['code'];
				const userId = params['state'];
				if (code) {
					this.exchangeAuthorizationCodeForTokens(code, userId);
				} else {
					this.state = CallbackState.error;
				}
			});
	}

	private exchangeAuthorizationCodeForTokens(
		code: string,
		userId: string,
	): void {
		this.titlePlusService
			.exchangeCodeForToken(code, userId)
			.pipe(take(1))
			.subscribe(
				(res: any) => {
					console.log('res', res);
					if (res.access_token) {
						this.state = CallbackState.success;
						this.openSuccessDialog();
					} else {
						this.state = CallbackState.error;
					}
				},
				(err) => {
					this.state = CallbackState.error;
					console.log('err', err);
				},
			);
	}

	openSuccessDialog(): void {
		this.dialog.open(this.successDialogTemplate, {
			width: '100%',
			panelClass: 'no-padding',
			hasBackdrop: false,
			disableClose: true,
		});
	}

	goToTitlePlus() {
		this.navService.goToProfile_Integrations_TitlePLUS();
	}
}
